import {IAllEntriesRemovedPayload} from 'src/app/shared/domain/interfaces/all-entries-removed-payload.interface';
import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export class AllEntriesRemovedEvent implements DomainEvent {
  readonly occurredAt = new Date();
  readonly eventType = "AllEntriesRemovedEvent";

  constructor(public readonly payload: IAllEntriesRemovedPayload) {
  }
}
